var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dhmap-wrapper"},[_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resize),expression:"resize"}],ref:"locatemap",attrs:{"id":"locatemap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }